<div class="auth-dialog-body">
  <div class="dialog-header">
    <button class="btn close-button p-0" (click)="onClose()" aria-label="Close">
      <img src="assets/icons/close.svg" alt="Close" />
    </button>
  </div>

  <div class="text-center my-3">
    <img src="assets/icons/lock.svg" class="img-fluid auth-icon" alt="Authentication Required" />
  </div>

  <h2 class="text-center dialog-title">{{ data.title }}</h2>
  <p class="text-center dialog-message">{{ data.message }}</p>

  <div class="d-sm-flex justify-content-center gap-3 mt-4 mb-2">
    <button class="btn loginBtn button-outline-primary mb-sm-0 mb-3" (click)="onLogin()">
      Login
    </button>
    <button class="btn signupBtn button-primary" (click)="onSignup()">Sign Up</button>
  </div>
</div>
